import { render, staticRenderFns } from "./ForeignData.vue?vue&type=template&id=5f318f3d&scoped=true&"
import script from "./ForeignData.vue?vue&type=script&lang=js&"
export * from "./ForeignData.vue?vue&type=script&lang=js&"
import style0 from "./ForeignData.vue?vue&type=style&index=0&id=5f318f3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f318f3d",
  null
  
)

export default component.exports